import {residentContextService} from "../services/resident-context";
import {useStoredMe} from "../store/me";
import type {ResidentMembership} from "../types/resident-membership";

/** Selected `properties[].memberships[]` row for the active resident context. */
export default function useResidentMembership(): ResidentMembership | null {
  const me = useStoredMe();
  return residentContextService.getSelectedMembership(me);
}
